import { set } from 'lodash/fp';
import createReducer from '../../../../../../helpers/createReducer';
import {
  fetchROPicklistForEdit,
  updateROPicklist
} from '../../../../sagas/routines';
import { resetROPicklistEdit } from '../../../../actions/routes/ro-picklist/edit';

const initialState = {
  data: null,
  fetching: false,
  fetched: false,
  saving: false,
  saved: false
};

const fetchROPicklistEditHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const updateROPicklistEditHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true
  })
});

const restROPicklistEditHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchROPicklistEditHandler(fetchROPicklistForEdit),
  ...updateROPicklistEditHandler(updateROPicklist),
  ...restROPicklistEditHandler(resetROPicklistEdit)
});
